import { ProductSourceEnum } from "api-client";

interface ProductWithOrgSource {
  dataset_source?: string | null;
  organisation_id?: string | null;
  organisation_name?: string | null;
}

export function getProductOrganisationName(
  product: ProductWithOrgSource | null | undefined,
  currentOrgId: string | undefined
): string | undefined {
  if (!product) return undefined;
  const source = product.dataset_source?.toLowerCase();
  if (source === ProductSourceEnum.Concular) return "Circular LCA";
  if (source === ProductSourceEnum.Manufacturer)
    return product.organisation_name ?? undefined;
  if (product.organisation_id && product.organisation_id === currentOrgId)
    return product.organisation_name ?? undefined;
  return undefined;
}
